import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

const DashboardLocatario = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        citas_totales: null, 
        citas_pendientes: null, 
        citas_finalizadas: null, 
        citas_canceladas: null, 
        dia_mas: null, 
        dia_menos: null, 
        horario_mas: null, 
        horario_menos: null, 
        cliente_citado: null, 
        cliente_paquetes: null, 
        servicio_solicitado: null, 
        ultima_cita: null, 
        proxima_cita: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('locatario'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                citas_totales: detalles.citas_totales || null, 
                citas_pendientes: detalles.citas_pendientes || null, 
                citas_finalizadas: detalles.citas_finalizadas || null, 
                citas_canceladas: detalles.citas_canceladas || null, 
                dia_mas: detalles.dia_mas || null, 
                dia_menos: detalles.dia_menos || null, 
                horario_mas: detalles.horario_mas || null, 
                horario_menos: detalles.horario_menos || null, 
                cliente_citado: detalles.cliente_citado || null, 
                cliente_paquetes: detalles.cliente_paquetes || null, 
                servicio_solicitado: detalles.servicio_solicitado || null, 
                ultima_cita: detalles.ultima_cita || null, 
                proxima_cita: detalles.proxima_cita || null
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    ¡Hola {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}!
                </h4>
            </div>

            <div className="col-md-5 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Citas</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_totales != null && dashboardData.citas_totales != undefined ? formatNumber(dashboardData.citas_totales, 0, '', '') : '0'}</p>
                                <p className="subtitulo">totales</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_pendientes != null && dashboardData.citas_pendientes != undefined ? formatNumber(dashboardData.citas_pendientes, 0, '', '') : '0'}</p>
                                <p className="subtitulo">pendientes</p>
                            </div>                            
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_finalizadas != null && dashboardData.citas_finalizadas != undefined ? formatNumber(dashboardData.citas_finalizadas, 0, '', '') : '0'}</p>
                                <p className="subtitulo">finalizadas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.citas_canceladas != null && dashboardData.citas_canceladas != undefined ? formatNumber(dashboardData.citas_canceladas, 0, '', '') : '0'}</p>
                                <p className="subtitulo">canceladas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-3 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Dias</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_mas != null && dashboardData.dia_mas != undefined ? dashboardData.dia_mas : 'Sin definir'}</p>
                                <p className="subtitulo">más citado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.dia_menos != null && dashboardData.dia_menos != undefined ? dashboardData.dia_menos : 'Sin definir'}</p>
                                <p className="subtitulo">menos citado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Horarios</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_mas != null && dashboardData.horario_mas != undefined ? dashboardData.horario_mas + ':00' : 'Sin definir'}</p>
                                <p className="subtitulo">más citado</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.horario_menos != null && dashboardData.horario_menos != undefined ? dashboardData.horario_menos + ':00' : 'Sin definir'}</p>
                                <p className="subtitulo">menos citado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Destacados</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_citado != null && dashboardData.cliente_citado != undefined ? dashboardData.cliente_citado : 'Sin definir'}</p>
                                <p className="subtitulo">cliente con más citas</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.cliente_paquetes != null && dashboardData.cliente_paquetes != undefined ? dashboardData.cliente_paquetes : 'Sin definir'}</p>
                                <p className="subtitulo">cliente con más paquetes</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.servicio_solicitado != null && dashboardData.servicio_solicitado != undefined ? dashboardData.servicio_solicitado : 'Sin definir'}</p>
                                <p className="subtitulo">servicio más solicitado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Mis acciones</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.ultima_cita != null && dashboardData.ultima_cita != undefined ? (dashboardData.ultima_cita.cliente ? [dashboardData.ultima_cita.cliente.nombre, dashboardData.ultima_cita.cliente.apellido_paterno, dashboardData.ultima_cita.cliente.apellido_materno, 'el '].join(' ') : '') + new Date(dashboardData.ultima_cita.fecha_inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(dashboardData.ultima_cita.fecha_inicio).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' }</p>
                                <p className="subtitulo">última cita</p>
                            </div>

                            <div className="col">
                                <p className="indicador">{dashboardData.proxima_cita != null && dashboardData.proxima_cita != undefined ? (dashboardData.proxima_cita.cliente ? [dashboardData.proxima_cita.cliente.nombre, dashboardData.proxima_cita.cliente.apellido_paterno, dashboardData.proxima_cita.cliente.apellido_materno, 'el '].join(' ') : '') + new Date(dashboardData.proxima_cita.fecha_inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(dashboardData.proxima_cita.fecha_inicio).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' }</p>
                                <p className="subtitulo">próxima cita</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardLocatario;